(function() {
  const body = document.querySelector('body');
  const header = document.querySelector('.header');
  const fadeOutLinks = document.querySelectorAll('.link--fadeOut, .account__pagination a');

  function toggleHeaderBackground() {
    if (body.getBoundingClientRect().top < 0) {
      header.classList.remove('header--animation');
    } else {
      header.classList.add('header--animation');
    }
  }

  function fadeOut(target) {
    body.classList.add('body--fadeOut');

    setTimeout(() => {
      window.location.href = target.href;
    }, 500);
  }

  fadeOutLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      fadeOut(e.currentTarget);
    });
  });

  window.addEventListener('scroll', toggleHeaderBackground);
})();
